import Loader from "../../loader";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HandleRenderDiv from "./HandleRenderDiv";

const HireTalent = ({ backToLogin, onClose }) => {
  const dispatch = useDispatch();
  const { subLoading, pagename, startStep } = useSelector(
    (state) => state.hireTalent.auth
  );

  
  return (
    <>
      <div
        className="modal d-block ct_large_modal_width ct_congratulation_modal_fade"
        tabIndex="-1"
      >
        {subLoading && <Loader />}
        <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
          <div class="modal-content">
            <div class="modal-header border-0 p-0 pb-2">
              <button
                type="button"
                class="btn-close ct_close_position_right12"
                onClick={onClose}
              ></button>
            </div>
            <HandleRenderDiv
              pagename={pagename}
              startStep={startStep}
              backToLogin={backToLogin}
              onClose={onClose}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HireTalent;
